<template>
  <div class="htDetails full-height">
    <ld-header
      style="position: absolute"
      @click-left="path ? $router.push({ path: path }) : $router.go(-1)"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
    </ld-header>

    <mescroll-vue
      ref="mescroll"
      :down="{ use: false }"
    >
      <div class="custom-van-swipe">
        <!--  -->
        <van-swipe @change="index => (van_swipe.current = index)">
          <van-swipe-item
            class="custom-imgbox"
            v-for="(image, index_) in van_swipe.images"
            :key="index_"
          >
            <img v-lazy="image">
          </van-swipe-item>

          <div
            class="custom-indicator"
            slot="indicator"
            @click="imagePreview(van_swipe.images, van_swipe.current)"
          >
            <ld-icon
              type="iconpicture"
              class="vertical-middle"
            />
            <span>{{ van_swipe.current + 1 }}/{{ van_swipe.images && van_swipe.images.length }}</span>
          </div>
        </van-swipe>
      </div>
      <van-sticky>
        <div class="skeletonDiv">
          <van-skeleton
            :row="4"
            :loading="loading"
            class="pd10"
            style="background: #fff;"
          >
            <div
              class="base-info custom-active-bg"
              @click="$router.push('/ht/htQuery/htMore')"
            >
              <div class="content-box">
                <div class="title-box">
                  <h1>
                    {{ data_.jdmc }}
                    <span v-if="data_.category == '5'">
                      <span class="label">豪华型</span>
                      <img
                        class="pic"
                        src="~Assets/images/ht/hotel_type_03.png"
                      >
                    </span>
                    <span v-if="data_.category == '4'">
                      <span class="label">高档型</span>
                      <img
                        class="pic"
                        src="~Assets/images/ht/hotel_type_01.png"
                      >
                    </span>
                    <span v-if="data_.category == '3'">
                      <span class="label">舒适型</span>
                      <img
                        class="pic"
                        src="~Assets/images/ht/hotel_type_02.png"
                      >
                    </span>
                    <span v-if="data_.category == '0' || data_.category == '1' || data_.category == '2'">
                      <span class="label">经济型</span>
                    </span>
                  </h1>
                </div>
                <div class="score-box">
                  <span class="num-box">
                    <strong class="num main-color">{{ data_.score }}</strong>分
                  </span>
                  <span class="desc">
                    {{
                      data_.renovationDate ? (data_.renovationDate + ' 装修') : ''
                    }} {{ data_.establishmentDate ? (data_.establishmentDate + ' 开业') : '' }}
                  </span>
                </div>
              </div>

              <ld-icon type="iconright right-pic" />
            </div>

            <van-row
              type="flex"
              class="loca-box"
              align="center"
              @click="toMap"
            >
              <van-col span="17">
                <span class="font12">
                  <span class="font-bold">{{ data_.address }}</span> <br>
                  {{ data_.districtname ? data_.districtname : '' }}
                  {{ data_.businessZonename ? (' / ' + data_.businessZonename) : '' }}
                </span>

                <p
                  class="font12 gray"
                  v-if="data_.distance"
                >
                  <span v-if="model.searchType == 0">距您直线距离<span class="main-color">{{
                    parseFloat(data_.distance) >= 1 ? (data_.distance + 'km') : ((parseFloat(data_.distance) * 1000) == 100 ? ('≤' + (parseFloat(data_.distance) * 1000) + 'm') : ((parseFloat(data_.distance) * 1000) + 'm'))
                  }}</span></span>
                  <span v-if="model.searchType == 3">
                    <span v-if="model._keywords.length > 10">
                      距酒店直线<span class="main-color">{{
                        parseFloat(data_.distance) >= 1 ? (data_.distance + 'km') : ((parseFloat(data_.distance) * 1000) == 100 ? ('≤' + (parseFloat(data_.distance) * 1000) + 'm') : ((parseFloat(data_.distance) * 1000) + 'm'))
                      }}</span>
                    </span>
                    <span v-else>
                      距<span class="cff4f3f">{{ model._keywords }}</span>直线<span class="main-color">{{
                        parseFloat(data_.distance) >= 1 ? (data_.distance + 'km') : ((parseFloat(data_.distance) * 1000) == 100 ? ('≤' + (parseFloat(data_.distance) * 1000) + 'm') : ((parseFloat(data_.distance) * 1000) + 'm'))
                      }}</span>
                    </span>
                  </span>
                </p>
              </van-col>
              <van-col
                class="main-color font12 text-center"
                offset="1"
                span="6"
              >
                <ld-icon
                  type="iconlocation"
                  size="20"
                  class="gray"
                />
                <br>
                <span class="gray">地图/周边</span>
              </van-col>
            </van-row>
          </van-skeleton>

          <div
            class="inquiry-box custom-active-bg mb5"
            v-if="false"
          >
            <div
              class="inquiry bg-lightColor Grid"
              @click="$router.push({path: '/ht/htQuery/htInquiry', query: { jdid: $route.query.jdid }})"
            >
              <div class="pd5-10">
                <a class="inquiry-title main-color font18">线上询价</a>
              </div>
              <div class="Grid-cell">
                <p class="mt10">
                  人工询价，直通酒店前台预订
                </p>
                <p>线下比价，找出市场最优资源</p>
              </div>
              <div class="pd5-10">
                <a class="inquiry-btn bg-main"><span>立即询价</span></a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="Grid Grid--1of3 van-hairline--bottom query-info__date bg-white pd12-28 mb5 temlDiv"
          @click="showDate"
        >
          <div class="Grid-cell text-center">
            <div class="Grid-cell--autoSize font12">
              {{ $t('H006', '入住日期') }}
            </div>
            <div
              class="Grid-cell--autoSize query-info__date--weight font12 main-color"
              v-if="this.$route.query.i==1 ? true : false"
            >
              {{ max }}&nbsp;<span class="font-normal">{{ maxweek }}</span>
            </div>
            <div
              v-else
              class="Grid-cell--autoSize query-info__date--weight font12 main-color"
            >
              {{ max }}&nbsp;<span class="font-normal">{{ maxweek }}</span>
            </div>
          </div>
          <div class="Grid-cell Grid-cell--center text-center font12">
            <span class="date-num">{{ $t('E017', '共') }}<span class="query-info__tips--color">{{
              model._days
            }}</span>晚</span>
            <div class="arrow-line arrow-line--white" />
          </div>
          <div class="Grid-cell text-center">
            <div class="Grid-cell--autoSize font12">
              {{ $t('H007', '离店日期') }}
            </div>
            <div
              class="Grid-cell--autoSize query-info__date--weight font12 main-color"
              v-if="this.$route.query.i==1 ? true : false"
            >
              {{ min }}&nbsp;<span class="font-normal">{{ minweek }}</span>
            </div>
            <div
              class="Grid-cell--autoSize query-info__date--weight font12 main-color"
              v-else
            >
              {{ min }}&nbsp;<span class="font-normal">{{ minweek }}</span>
            </div>
          </div>
        </div>
      </van-sticky>

      <div class="fxListDiv">
        <van-skeleton
          avatar
          :row="3"
          :loading="loading"
          avatar-size="74"
          class="pd10"
          style="background: #fff;"
        >
          <div class="items-content-box">
            <div
              class="text-center pd10"
              v-if="data_.hotelRoom && !data_.hotelRoom.length"
            >
              <img
                style="width: 60%;"
                src="~/Assets/images/ht/no_room.png"
              >
              <p class="cccc">
                没有查询到符合条件的房间！
              </p>
              <p class="cccc">
                请选择其它酒店或者修改日期和人数重新查询。
              </p>
            </div>
            <div
              class="items-box"
              v-for="(item, index) in filteredRatePlans|| []"
              :key="'filtered_' + index"
            >
              <div class="items-box-padding custom-active-bg">
                <div class="items-box-border">
                  <div class="item-img custom-imgbox">
                    <img
                      class="list-item-img"
                      v-lazy="item.roomsImgs && item.roomsImgs[0]"
                      @click="popupAssignment(item)"
                    >
                  </div>
                  <div
                    class="item-info info_2"
                    @click="item.visible = !item.visible"
                  >
                    <div>
                      <p style="font-weight: 700;">
                        {{ item.fxmc }}
                      </p>
                    </div>
                    <div>
                      <ul class="van-clearfix">
                        <li>
                          {{ item.description }} <span
                            v-show="item.window"
                          >{{ item.window == '0' ? '有窗' : item.window == '1' ? '部分有窗' : '无窗' }}</span>
                        </li>
                      </ul>
                    </div>
                    <!-- 预留，可通过查看hotelRoom.js中的 *htQuery/hotelRoom 配置信息 -->
                    <div>
                      <p class="explain" />
                      <p class="cash">
                        <span>
                          &yen;
                          <strong>{{ item.minFacePrice ? item.minFacePrice : item.ratePlans[0].firstPrice }}</strong>
                        </span>{{ $t('rise', '起') }}
                      </p>
                    </div>
                  </div>
                  <ld-icon
                    :class="item.visible ? 'active' : ''"
                    type="icondown more"
                    @click="item.visible = !item.visible"
                  />
                </div>
              </div>
              <div class="van-slide-down-box">
                <transition name="van-slide-down">
                  <div
                    class="sub-box"
                    v-show="item.visible"
                  >
                    <div
                      class="sub-item custom-active-bg"
                      v-for="(i, index_) in item.ratePlans"
                      :key="index_"
                    >
                      <div
                        class="sub-item-info"
                        @click="openCanPopup(item, i)"
                      >
                        <p class="name">
                          {{ i.rpName }}
                        </p>
                        <p class="name">
                          <span
                            v-if="i.payment == 1"
                            class="label bg_45bf98"
                          >到店付</span>
                          <span
                            v-if="i.payment == 2"
                            class="label bg_ec6351"
                          >{{ $t('H030', '预付') }}</span>
                          <!-- 处理发票展示 start -->
                          <span
                            v-if="i.invoiceMode === 'Plat'"
                            class="label bg_ec6351"
                          >供应开票</span>
                          <span
                            v-if="i.invoiceMode === 'Hotel'"
                            class="label bg_ec6351"
                          >酒店开票</span>
                          <!-- 处理发票展示 end -->
                          <!-- 处理聚合酒店供应展示 start -->
                          <span
                            v-if="i.ratePlanFromShow"
                            class="label bg_ec6351"
                          >{{ i.ratePlanFromShow }}</span>
                          <!-- 处理聚合酒店供应展示 end -->
                          <span
                            v-show="i.bussType==2 || i.priceSourceType == 2"
                            class="name-label"
                          >协议</span>
                          <span
                            v-show="i.bussType == 1 || i.priceSourceType == 1"
                            class="name-label bgff923e"
                          >特惠</span>

                          <span
                            class="wei"
                            v-if="iswb(i)"
                          >{{ $t('K303','违') }}</span>

                          <!-- 客人类型 OtherForeign: 外宾价 -->
                          <span
                            v-if="i.customerType == 'OtherForeign'"
                            class="label bg_3196fb"
                          >外</span>
                        </p>
                        <p class="contain">
                          <span v-if="!i.freeMeal">{{ $t('H029','不含早') }}</span>
                          <span v-else>含{{ i.freeMeal }}份早餐</span>
                          &nbsp;
                          <!-- <span> {{ i.window == '0' ? '有窗' : i.window == '1' ? '部分有窗' : '无窗' }} </span> -->
                          <span v-show="item.window">{{ item.window == '0' ? '有窗' : item.window == '1' ? '部分有窗' : '无窗' }}</span>
                        </p>
                        <p class="guarantee">
                          <a v-if="i.shortRule == 11">无需担保</a>
                          <a v-if="i.shortRule == 12">限时担保</a>
                          <a v-if="i.shortRule == 13">强制担保</a>
                          <a v-if="i.shortRule == 21">{{ $t('H069','免费取消') }}</a>
                          <a v-if="i.shortRule == 22">{{ $t('H028','限时取消') }}</a>
                          <a v-if="i.shortRule == 23">{{ $t('H033','不可取消') }}</a>
                          <a v-if="!i.shortRule">查看规则</a>
                        </p>
                        <p class="cash">
                          &yen;
                          <strong>{{ i.firstPrice }}</strong>
                        </p>
                      </div>
                      <!--
                      能否预订酒店需要根据下面条件综合判断
                      1、因私出行可预订
                      2、因公出行 && 第一晚的房间价格是否超出了[当前登录人/选择的出行人/多个出行人按差标等级最低的进行匹配]差旅标准规定的房间价格 [超出不可预订] && 差旅标准的管控方式为2[1: 只做提醒 2: 不允许预订]
                      3、差旅标准的管控方式为1[1: 只做提醒 2: 不允许预订]

                      注：添加class类 [no] 按钮不可点击状态
                    -->

                      <a
                        class="book-btn linear-main1"
                        v-if="i.allRoomStatus != 2 && pageCtrl.isStart"
                        :class="canbook(i) ? '' : 'no'"
                        @click="canbook(i) && book(i)"
                      >
                        <p>订</p>
                        <span
                          v-if="i.allRoomStatus == 0"
                          style="color: #181818;"
                        >良好</span>
                        <span v-if="i.allRoomStatus == 1">{{ $t('jz','紧张') }}</span>
                        <span v-if="i.allRoomStatus == 3">{{ $t('xqr','需确认') }}</span>
                      </a>
                      <a
                        class="book-btn linear-main1"
                        v-if="i.allRoomStatus != 2 && !pageCtrl.isStart"
                        @click="book(i)"
                      >
                        <p>订</p>
                        <span
                          v-if="i.allRoomStatus == 0"
                          style="color: #181818;"
                        >良好</span>
                        <span v-if="i.allRoomStatus == 1">{{ $t('jz','紧张') }}</span>
                        <span v-if="i.allRoomStatus == 3">{{ $t('xqr','需确认') }}</span>
                      </a>
                      <a
                        class="book-btn no"
                        v-if="i.allRoomStatus == 2"
                      >
                        <p>订</p>
                        <span class="c999">已满房</span>
                      </a>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div
              class="items-box"
              v-for="(item, index) in nonFilteredRatePlans || []"
              :key="'nonFiltered_' + index"
            >
              <div class="items-box-padding custom-active-bg">
                <div class="items-box-border">
                  <div class="item-img custom-imgbox">
                    <img
                      class="list-item-img"
                      v-lazy="item.roomsImgs && item.roomsImgs[0]"
                      @click="popupAssignment(item)"
                    >
                  </div>
                  <div
                    class="item-info info_2"
                    @click="item.visible = !item.visible"
                  >
                    <div>
                      <p style="font-weight: 700;">
                        {{ item.fxmc }}
                      </p>
                    </div>
                    <div>
                      <ul class="van-clearfix">
                        <li>
                          {{ item.description }} <span
                            v-show="item.window"
                          >{{ item.window == '0' ? '有窗' : item.window == '1' ? '部分有窗' : '无窗' }}</span>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <!-- 预留，可通过查看hotelRoom.js中的 *htQuery/hotelRoom 配置信息 -->

                      <p class="explain" />
                      <p class="cash">
                        <span>
                          &yen;
                          <strong>{{ item.minFacePrice ? item.minFacePrice : item.ratePlans[0].firstPrice }}</strong>
                        </span>{{ $t('rise', '起') }}
                      </p>
                    </div>
                  </div>
                  <div class="Ydw">
                    <span style="color: #ccc">已订完</span>
                    <ld-icon
                      :class="item.visible ? 'active' : ''"
                      type="icondown more"
                      @click="item.visible = !item.visible"
                    />
                  </div>
                </div>
              </div>
              <div class="van-slide-down-box">
                <transition name="van-slide-down">
                  <div
                    class="sub-box"
                    v-show="item.visible"
                  >
                    <div
                      class="sub-item custom-active-bg"
                      v-for="(i, index_) in item.ratePlans"
                      :key="index_++"
                    >
                      <div
                        class="sub-item-info"
                        @click="openCanPopup(item, i)"
                      >
                        <p class="name">
                          {{ i.rpName }}
                        </p>
                        <p class="name">
                          <span
                            v-if="i.payment == 1"
                            class="label bg_45bf98"
                          >到店付</span>
                          <span
                            v-if="i.payment == 2"
                            class="label bg_ec6351"
                          >{{ $t('H030', '预付') }}</span>
                          <!-- 处理发票展示 start -->
                          <span
                            v-if="i.invoiceMode === 'Plat'"
                            class="label bg_ec6351"
                          >供应开票</span>
                          <span
                            v-if="i.invoiceMode === 'Hotel'"
                            class="label bg_ec6351"
                          >酒店开票</span>
                          <!-- 处理发票展示 end -->
                          <!-- 处理聚合酒店供应展示 start -->
                          <span
                            v-if="i.ratePlanFromShow"
                            class="label bg_ec6351"
                          >{{ i.ratePlanFromShow }}</span>
                          <!-- 处理聚合酒店供应展示 end -->
                          <span
                            v-show="i.bussType==2 || i.priceSourceType == 2"
                            class="name-label"
                          >协议</span>
                          <span
                            v-show="i.bussType == 1 || i.priceSourceType == 1"
                            class="name-label bgff923e"
                          >特惠</span>

                          <span
                            class="wei"
                            v-if="iswb(i)"
                          >{{ $t('K303', '违') }}</span>

                          <!-- 客人类型 OtherForeign: 外宾价 -->
                          <span
                            v-if="i.customerType == 'OtherForeign'"
                            class="label bg_3196fb"
                          >外</span>
                        </p>
                        <p class="contain">
                          <span v-if="!i.freeMeal">{{ $t('H029', '不含早') }}</span>
                          <span v-else>含{{ i.freeMeal }}份早餐</span>
                          <span> {{ i.window == '0' ? '有窗' : i.window == '1' ? '部分有窗' : '无窗' }} </span>
                        </p>
                        <p class="guarantee">
                          <a v-if="i.shortRule == 11">无需担保</a>
                          <a v-if="i.shortRule == 12">限时担保</a>
                          <a v-if="i.shortRule == 13">强制担保</a>
                          <a v-if="i.shortRule == 21">{{ $t('H069', '免费取消') }}</a>
                          <a v-if="i.shortRule == 22">{{ $t('H028', '限时取消') }}</a>
                          <a v-if="i.shortRule == 23">{{ $t('H033', '不可取消') }}</a>
                          <a v-if="!i.shortRule">查看规则</a>
                        </p>
                        <p class="cash">
                          &yen;
                          <strong>{{ i.firstPrice }}</strong>
                        </p>
                      </div>
                      <!--
                      能否预订酒店需要根据下面条件综合判断
                      1、因私出行可预订
                      2、因公出行 && 第一晚的房间价格是否超出了[当前登录人/选择的出行人/多个出行人按差标等级最低的进行匹配]差旅标准规定的房间价格 [超出不可预订] && 差旅标准的管控方式为2[1: 只做提醒 2: 不允许预订]
                      3、差旅标准的管控方式为1[1: 只做提醒 2: 不允许预订]

                      注：添加class类 [no] 按钮不可点击状态
                    -->

                      <a
                        class="book-btn linear-main1"
                        v-if="i.allRoomStatus != 2 && pageCtrl.isStart"
                        :class="canbook(i) ? '' : 'no'"
                        @click="canbook(i) && book(i)"
                      >
                        <p>订</p>
                        <span
                          v-if="i.allRoomStatus == 0"
                          style="color: #181818;"
                        >良好</span>
                        <span v-if="i.allRoomStatus == 1">{{ $t('jz', '紧张') }}</span>
                        <span v-if="i.allRoomStatus == 3">{{ $t('xqr', '需确认') }}</span>
                      </a>
                      <a
                        class="book-btn linear-main1"
                        v-if="i.allRoomStatus != 2 && !pageCtrl.isStart"
                        @click="book(i)"
                      >
                        <p>订</p>
                        <span
                          v-if="i.allRoomStatus == 0"
                          style="color: #181818;"
                        >良好</span>
                        <span v-if="i.allRoomStatus == 1">{{ $t('jz', '紧张') }}</span>
                        <span v-if="i.allRoomStatus == 3">{{ $t('xqr', '需确认') }}</span>
                      </a>
                      <a
                        class="book-btn no"
                        v-if="i.allRoomStatus == 2"
                      >
                        <p>订</p>
                        <span class="c999">已满房</span>
                      </a>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </van-skeleton>
      </div>
      <van-popup
        v-model="van_popup.show"
        round
        closeable
        position="bottom"
        :close-on-popstate="true"
        :style="{ 'background-color': '#f6f6f5', 'padding-bottom': '55px' }"
      >
        <div class="custom-van-swipe- custom-van-swipe-box">
          <div class="title">
            {{ van_popup.i.rpName }}
          </div>
          <van-swipe @change="index => (van_popup.item.current = index)">
            <van-swipe-item
              class="custom-imgbox"
              v-for="(image, index) in van_popup.item.roomsImgs"
              :key="index"
            >
              <img v-lazy="image">
            </van-swipe-item>

            <div
              class="custom-indicator"
              slot="indicator"
              @click="imagePreview(van_popup.item.roomsImgs, van_popup.item.current)"
            >
              <ld-icon
                type="iconpicture"
                class="vertical-middle"
              />
              <span>{{ van_popup.item.current + 1 }}/{{ van_popup.item.roomsImgs && van_popup.item.roomsImgs.length }}</span>
            </div>
          </van-swipe>
        </div>
        <div class="items-box-popup popup-items-box mb10 p-b-10">
          <div class="item-info">
            <h3>房型设施</h3>
            <div class="Grid Grid--1of2 item-info-box">
              <div
                class="Grid-cell"
                v-if="van_popup.item.area"
              >
                <span>面积</span>{{ van_popup.item.area }}平米
              </div>
              <div
                class="Grid-cell"
                v-if="van_popup.item.bedType"
              >
                <span>床型</span>{{ van_popup.item.bedType }}
              </div>
              <div
                class="Grid-cell"
                v-if="van_popup.item.floor"
              >
                <span>楼层</span>{{ van_popup.item.floor }}层
              </div>
              <div
                class="Grid-cell"
                v-if="van_popup.item.capacity"
              >
                <span>可住</span>可入住{{ van_popup.item.capacity }}人
              </div>
              <div class="Grid-cell">
                <span>网络</span>{{ van_popup.item.broadnetFee == '0' ? '免费宽带' : '收费宽带' }}
              </div>
              <div
                class="Grid-cell"
                v-show="van_popup.item.window"
              >
                <span>窗型</span>{{ van_popup.item.window == '0' ? '有窗' : van_popup.item.window == '1' ? '部分有窗' : '无窗' }}
              </div>
              <div
                class="Grid-cell"
                v-show="van_popup.i.window"
              >
                <span>窗型</span>{{ van_popup.i.window == '0' ? '有窗' : van_popup.i.window == '1' ? '部分有窗' : '无窗' }}
              </div>
            </div>
          </div>
        </div>
        <div class="items-box-popup popup-items-box mb10 p-b-10">
          <div class="item-info">
            <h3>{{ van_popup.i.payment == 1 ? '担保规则' : '取消规则' }}</h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                <div v-if="van_popup.i.shortRule == 11">
                  <a class="main-color">{{ $t('H081','无需担保') }}</a>{{ van_popup.i.guaranteeRule.changeRule || '无需提前支付房费' }}
                </div>
                <div v-if="van_popup.i.shortRule == 12 && van_popup.i.guaranteeRule">
                  <a class="main-color">{{ $t('H082','限时担保') }}</a>{{ van_popup.i.guaranteeRule.description }}
                </div>
                <div v-if="van_popup.i.shortRule == 13 && van_popup.i.guaranteeRule">
                  <a class="main-color">{{ $t('H083','强制担保') }}</a>{{ van_popup.i.guaranteeRule.description }}
                </div>
                <div v-if="van_popup.i.shortRule == 21 && van_popup.i.prepayRule">
                  <a class="main-color">{{ $t('H069','免费取消') }}</a>{{ van_popup.i.prepayRule.description }}
                </div>
                <div v-if="van_popup.i.shortRule == 22 && van_popup.i.prepayRule">
                  <a class="main-color">{{ $t('H028','限时取消') }}</a>{{ van_popup.i.prepayRule.description }}
                </div>
                <div v-if="van_popup.i.shortRule == 23 && van_popup.i.prepayRule">
                  <a class="main-color">{{ $t('H033','不可取消') }}</a>{{ van_popup.i.prepayRule.description }}
                </div>
                <div v-if="!van_popup.i.shortRule && van_popup.i.prepayRule">
                  {{ van_popup.i.prepayRule.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="pageCtrl.isStart && model._policy.clzcJe"
        >
          <div class="item-info">
            <h3>差旅标准</h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                <div>
                  <span
                    v-if="iswb(van_popup.i)"
                    class="red"
                  >违背</span>
                  <span
                    v-else
                    class="green"
                  >符合</span>
                  标准，平均不得高于{{ model._policy.clzcJe }}元/间夜
                </div>
              </div>
            </div>
          </div>
        </div>
        <ld-tabbar
          ref="tabbar"
          :price-list="priceList"
        >
          <van-row
            class="full-width bg-white"
            type="flex"
            align="center"
          >
            <van-col span="1" />
            <van-col span="14">
              <p
                style="font-size: 12px;"
              >
                {{ van_popup.i.payment == 1 ? '到店付' : $t('H030','预付') }}
                <span
                  v-if="van_popup.i.allRoomStatus == 1"
                  class="tabbar-label bgff5655"
                >{{ $t('jz','紧张') }}</span>
                <span
                  class="wei"
                  v-if="iswb(van_popup.i)"
                >{{ $t('K303','违') }}</span>
              </p>
              <span class="font12 red">&yen;</span>
              <span
                class="font44 red"
              >
                <strong>{{ van_popup.i.firstPrice }}</strong>
              </span>
            </van-col>
            <van-col
              span="8"
              class="pad-r-8"
            >
              <ld-button
                v-if="van_popup.i.allRoomStatus != 3 && pageCtrl.isStart"
                :loading="isLoading"
                size="md"
                main
                :disabled="!canbook(van_popup.i)"
                @click="canbook(van_popup.i) && book(van_popup.i)"
              >
                立即预订
              </ld-button>
              <ld-button
                v-if="van_popup.i.allRoomStatus != 3 && !pageCtrl.isStart"
                :loading="isLoading"
                size="md"
                main
                @click="book(van_popup.i)"
              >
                立即预订
              </ld-button>
              <ld-button
                v-if="van_popup.i.allRoomStatus == 3"
                :loading="isLoading"
                size="md"
                main
                disabled
              >
                已满房
              </ld-button>
            </van-col>
            <van-col span="1" />
          </van-row>
        </ld-tabbar>
      </van-popup>

      <div
        class="no-more pd10-0 text-center"
        v-if="data_.hotelRoom && data_.hotelRoom.length"
      >
        没有更多数据了~
      </div>

      <!-- 酒店选择入住/离店日期控件 -->
      <Ld-calendar
        ref="date"
        type="range"
        @selected="getDate"
      />

      <!-- 上拉菜单：违背差旅政策 -->
      <!-- <violate-list
        cplx="10903"
        :violate="clzcStr"
        ref="violateList"
        @selected="jump"
      /> -->
      <violate-list
        cplx="11602040"
        :violate="clzcStr"
        ref="violateList"
        @selected="jump"
      />
    </mescroll-vue>

    <!-- 通过组件方式调用 -->
    <van-image-preview
      ref="imagePreview"
      v-model="van_image_preview.show"
      :images="van_image_preview.images"
      @change="onChange"
      async-close
      class-name="custom-image-preview"
    >
      <div slot="cover">
        <div class="Grid van-image-preview-north">
          <div class="Grid-cell text-center">
            {{ van_image_preview.item.fxmc }}
          </div>
          <ld-icon
            class="close-icon"
            type="iconclose"
            @click="$refs['imagePreview'].close()"
          />
        </div>
        <div class="Grid Grid--1of3 van-image-preview-box">
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.area"
          >
            {{ van_image_preview.item.area }}平米
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.bedType"
          >
            {{ van_image_preview.item.bedType }}
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.floor"
          >
            {{ van_image_preview.item.floor }}层
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.capacity"
          >
            可入住{{ van_image_preview.item.capacity }}人
          </div>
          <div class="Grid-cell">
            {{ van_image_preview.item.broadnetFee == '0' ? '免费宽带' : '收费宽带' }}
          </div>
        </div>
      </div>
    </van-image-preview>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  ImagePreview,
  Popup,
  ActionSheet,
  Cell,
  CellGroup,
  RadioGroup,
  Radio,
  Skeleton,
  Sticky
} from 'vant'
import {formatDate, getDiffDays} from 'Utils/dateUtil'
import {mapState, mapGetters} from 'vuex'
import {getHotelRoom} from './hotelRoom'
import hotelMixin from '../hotelMixin'
import Vue from 'vue'
import {is_weixn} from '@/common/utils/plus'
import {bd09togcj02} from '@/business/utils/convertGps'
import defaultMixin from '@/business/mixins/default'
import {isXlminp} from 'Utils/xltools'

Vue.use(ImagePreview)

export default {
  name: 'HtDetails',
  mixins: [hotelMixin, defaultMixin],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImagePreview.name]: ImagePreview,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Skeleton.name]: Skeleton,
    [Sticky.name]: Sticky,
    LdCalendar: () => import('Common/ldCalendar'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    ldButton: () => import('Common/ldButton'),
    violateList: () => import('Components/violateList')
  },
  data() {
    return {
      max:'',
      min:'',
      minweek:'',
      maxweek:'',
      /**
       * 页面差旅标准对象
       */
      van_swipe: {
        current: 0,
        images: []
      },
      van_image_preview: {
        show: false,
        images: [],
        index: 0,
        item: {}
      },
      van_popup: {
        item: {},
        i: {},
        show: false
      },
      violation: '',
      violationItems: [],
      otherReasonDesc: '',
      priceList: [],
      isLoading: false,
      loading: false,
      path: '',
      clzcStr: '',
      __data: [],
      timer: null,
      filteredRatePlans: [],
      nonFilteredRatePlans: [],
    }
  },
  computed: {
    ...mapState ({
      model: (state) => state.ht.htSearchInfo,
      /**
       * 酒店详情数据模型
       */
      data_: (state) => state.ht.orderDetails,
      interfacePlat: (state) => state.ht.interfacePlat,
      pageCtrl: (state) => state.ht.pageCtrl,
    }),
    ...mapGetters({
      travelerList:'ht/travelerList',
    }),
    // filteredRatePlans() {
    // 	return this.__data.filter(ratePlan => {
    // 		console.log(ratePlan)
    // 		return ratePlan.ratePlans.some(plan => plan.allRoomStatus === '0')
    // 	})
    // },
    // nonFilteredRatePlans() {
    // 	// 过滤满足条件的ratePlans
    // 	return this.__data.filter(ratePlan => {
    // 		console.log(ratePlan)
    // 		return ratePlan.ratePlans.every(plan => plan.allRoomStatus !== '0')
    // 	})
    // },
  },
  created () {
    this.loadData()
    if (this.$route.query.i == 1) {
      this.max = formatDate(this.model.checkInDate).monDay
      this.maxweek = formatDate(this.model.checkInDate).week
      this.min = formatDate(this.model.checkOutDate).monDay
      this.minweek = formatDate(this.model.checkOutDate).week
    }else{
      this.max = formatDate(this.model.checkInDate).monDay2
      this.maxweek = formatDate(this.model.checkInDate).week
      this.min = formatDate(this.model.checkOutDate).monDay2
      this.minweek = formatDate(this.model.checkOutDate).week
    }
  },
  mounted() {
    this.__data = this.data_.hotelRoom
    console.log(this.__data, '555')
  },
  methods: {
    /**
     * 初始化酒店详情数据
     */
    loadData() {
      this.loading = true
      this.clzcStr = `违背标准，平均不得高于${this.model._policy.clzcJe}元/间夜`
      this.van_popup.show = false
      console.log('htDteails.loadData.this : ', this)
      console.log('htDteails.loadData.hotelInterfaceBeans.string : ', this.$route.query.hotelInterfaceBeans)
      getHotelRoom(this, {
        jdid: this.$route.query.jdid,
        checkInDate: this.model.checkInDate,
        checkOutDate: this.model.checkOutDate,
        tripType: this.model.tripType,
        interfacePlatEnum: this.interfacePlat.interfacePlatId,
        protocol: this.$route.query.protocol,
        hotelInterfaceBeans: JSON.parse(this.$route.query.hotelInterfaceBeans)
      }).then(v => {
        let res_ = v[0],
          res = v[1]
        /**
			   * 将获取到的酒店图片存储到this.van_swipe.images
			   */
        let _images = []
        if (res_.data.hotelImgs) {
          res_.data.hotelImgs[0].url.forEach(element => {
            _images.push(element)
          })
        }
        this.van_swipe.images = _images.length ? _images : ['http://via.placeholder.com/375']

        res.data.hotelRoom = v[2]
        // 通过房型id匹配房型图片合集，将房型图片数据合到房型对象信息中
        res.data.hotelRoom.forEach(element => {
          element.roomsImgs = []
        })
        if (res_.data.roomsImgs) {
          res_.data.roomsImgs.forEach(element_ => {
            res.data.hotelRoom.forEach(element => {
              if (element_.fxid == element.fxid) {
                //element.roomsImgs = element_.url
                element.roomsImgs.push(element_.url[0])

                if (element.roomsImgs.length === 0 && element.imageUrl) {
                  element.roomsImgs.push(element.imageUrl)
                }
              }
            })
          })
        }
        res.data.protocol = this.$route.query.protocol

        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, res.data || { jdid: this.$route.query.jdid }))
        this.loading = false
        this.__data = this.data_
      }).catch(e => {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, { hotelRoom: [] }))
        this.loading = false
        throw e
      })
    },
    toMap () {
      if (is_weixn() && !isXlminp()) {// 行路的微信小程序除外
        var pos = bd09togcj02(this.data_.baiduLon, this.data_.baiduLat)
        this.$router.push({path: '/ht/htQuery/htMap', query: {lon: this.data_.baiduLon, lat: this.data_.baiduLat}})

        // wx.openLocation({
        // 	latitude: Number(this.data_.baiduLon),
        // 	longitude: Number(this.data_.baiduLat),
        // 	address: this.data_.address,
        // 	scale: 14,
        // 	success: () => {
        // 		console.log('小程序地图跳转成功：' + this.data_)
        // 	},
        // 	fail: (err) => {
        // 		console.error(err)
        // 		this.$toast({
        // 			type: 'fail',
        // 			message: `小程序地图跳转失败，具体失败信息：${err.errMsg}`
        // 		})
        // 	}
        // })
        console.log('pos', pos)
      } else {
        this.$router.push({path: '/ht/htQuery/htMap', query: {lon: this.data_.baiduLon, lat: this.data_.baiduLat}})
      }
    },
    /**
     * 图片预览操作
     * @param {*} index
     */
    imagePreview(roomsImgs, index) {
      ImagePreview({
        images: roomsImgs,
        startPosition: index
      })
    },
    showDate(){
      if(this.pageCtrl.isChangeDate){
        let maxDate=''
        if(this.model._max_date){
          maxDate=this.model._max_date
        }else{
          maxDate= formatDate(this.model._min_date,90).date
        }
        this.$refs.date.toggle({
          defaultDate:[this.model._checkInDate.date,this.model._checkOutDate.date],
          minDate:this.model._min_date,
          maxDate:maxDate,
        })
      }
    },
    /**
     * 酒店选择入住/离店日期回调
     * @param {*} data
     */
    async getDate(data) {

      [this.model.checkInDate,this.model.checkOutDate] = data;
      [this.model._checkInDate,this.model._checkOutDate] = [formatDate(data[0]),formatDate(data[1])]
      this.model._days = getDiffDays(this.model.checkInDate,this.model.checkOutDate)
      this.max = formatDate(data[0]).monDay
      this.maxweek = formatDate(data[0]).week
      this.min = formatDate(data[1]).monDay
      this.minweek = formatDate(data[1]).week
      await this.$store.dispatch('ht/getTravelPolicy')
      /**
       * 重新加载列表
       * 重新加载列表
       */
      this.loadData()
    },
    /**
     * 点击房型下的价格计划
     * 为弹出菜单层赋值
     */
    popupAssignment(item) {
      if (item.roomsImgs && item.roomsImgs.length > 0) {
        this.van_image_preview.item = item
        this.van_image_preview.show = true
        this.van_image_preview.images = item.roomsImgs
      }
    },
    /**
     * 预订酒店
     */
    book(i) {
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _ratePlans: i
      }))
      /**
       * 是否满房
       */
      if (i.allRoomStatus == 2) {
        return this.$toast('您选择的房型已住满，请重新选择！')
      }

      /**
       * 判断是否违背
       * 获取违背原因
       */
      if (this.iswb(i)) {
        if (!this.violationItems.length) {
          this.$api['htQuery/violateReasonList']().then(res => {
            this.violationItems = res.data
            this.$refs['violateList'].toggle()
            this.violation = this.violationItems[0].reasonCode+','+this.violationItems[0].reasonDesc
          }).catch(() => {})
        } else {
          this.$refs['violateList'].toggle()
        }
      } else {
        this.priceValidate()
      }
    },

    onChange(index) {
      this.index = index
    },
    openCanPopup(item, i) {
      item.current = 0
      this.van_popup.item = item
      this.van_popup.i = i
      this.van_popup.show = true
    },
    jump(obj) {
      this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
        _reason: {
          reasonCode: obj.reasonCode,
          reasonDesc: obj.reasonDesc,
        },
        _violation: {
          reasonCode: obj.reasonCode,
          reasonDesc: obj.reasonDesc,
          violateitem: '本次预订差旅标准，平均不得高于' + this.model._policy.clzcJe + '元/间夜'
        }
      }))

      this.priceValidate()
    },
    // 验价格
    async priceValidate () {
      // checkInDate: this.model._checkInDate.date,
      // checkOutDate: this.model._checkOutDate.date,
      // 判断处理中宏越供应生单
      let interfacePlatEnum = this.interfacePlat.interfacePlatId
      console.log('priceValidate interfacePlatEnum be  : ', interfacePlatEnum)
      if(interfacePlatEnum != '2000059'){
        interfacePlatEnum = this.data_._ratePlans.fyid
      }
      console.log('priceValidate interfacePlatEnum af  : ', interfacePlatEnum)

      const {data = {}} = await this.$api['htQuery/priceValidate']({
        // hotelId: this.$route.query.jdid,
        hotelId: this.$route.query.jdid + '&' + this.data_._ratePlans.ptJdid,
        checkInDate: this.model.checkInDate,
        checkOutDate: this.model.checkOutDate,
        tripType: this.model.tripType,
        roomId: this.data_._ratePlans.roomId,
        ratePlanId: this.data_._ratePlans.ratePlanId,
        // interfacePlatEnum: this.interfacePlat.interfacePlatId,
        interfacePlatEnum: interfacePlatEnum,
        singaZhid: this.interfacePlat.singaZhid,
        searchPlatZhid: this.interfacePlat.platZhid,
        protocol: this.data_._ratePlans.protocol
      })

      // 价格有变动
      if (data.valiStatus === 1) {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
          _ratePlans: data.planRateBean,
          valiStatus: data.valiStatus
        }))
      }

      // this.$router.push({path: this.model.path})
      this.$router.push({
        path: this.model.path,
        query: {
          ccsqdId: this.$route.query.ccsqdId,
          routeId: this.$route.query.routeId,
          i:this.$route.query.i
        }
      })
    }
  },
  watch: {
    data_: function (data) {
      const filteredRatePlans = data.hotelRoom.filter(ratePlan => {
        return ratePlan.ratePlans.some((plan) => {
          return plan.allRoomStatus !== '2'

        })
      })
      const filteredRatePlans1 = data.hotelRoom.filter(ratePlan => {
        return ratePlan.ratePlans.every((plan) => {
          return plan.allRoomStatus === '2'

        })
      })
      this.filteredRatePlans = filteredRatePlans
      this.nonFilteredRatePlans = filteredRatePlans1
      console.log()
    },
  },

}
</script>
<style lang="less" scoped src="./index.less"></style>
